var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-tags-input',{staticClass:"tags-input",attrs:{"tags":_vm.selectedTags,"add-only-from-autocomplete":_vm.noCreation,"max-tags":_vm.limit,"autocomplete-items":_vm.filteredTags,"add-on-key":_vm.key,"save-on-key":_vm.key},on:{"tags-changed":function (t) { return _vm.$emit(
        'input',
        t.map(function (v) { return v.text; })
      ); }},scopedSlots:_vm._u([(_vm.displayCount)?{key:"tag-right",fn:function(ref){
      var tag = ref.tag;
return [_vm._v(" ("+_vm._s(tag.count)+") ")]}}:null],null,true),model:{value:(_vm.currentTag),callback:function ($$v) {_vm.currentTag=$$v},expression:"currentTag"}})}
var staticRenderFns = []

export { render, staticRenderFns }